const filterSoal = {
    idBankSoal: null,
    idKelas: null,
    idMataPelajaran: null,
    idTematik: null,
    idUploadHistory: null,
    tipeSoal: null
}

export default filterSoal;